import axiosInstance from './axiosInstance';

export const createSlip = (request) => axiosInstance.post("/CommissionSlip/CreateSlip", request);
export const getPendingApprovals = () => axiosInstance.get("/CommissionSlip/GetPendingApprovals");
export const getPendingCount = () => axiosInstance.get("/CommissionSlip/GetPendingCount");
export const getMySlips = () => axiosInstance.get("/CommissionSlip/GetMySlips");
export const getAllSlips = () => axiosInstance.get("/CommissionSlip/GetAllSlips");
export const approveSlip = (slipId) => axiosInstance.put("/CommissionSlip/ApproveSlip", { slipId });
export const rejectSlip = (slipId, remarks) => axiosInstance.put("/CommissionSlip/RejectSlip", { slipId, remarks });
export const getSlipsByAgent = (agentId) => axiosInstance.get(`/CommissionSlip/GetSlipsByAgent?agentId=${agentId}`);
export const bulkGenerateSlips = (month, year, round) => axiosInstance.post("/CommissionSlip/BulkGenerate", { month, year, round: round || null });
export const voidSlip = (slipId, remarks) => axiosInstance.put("/CommissionSlip/VoidSlip", { slipId, remarks });
export const exportMakerCsv = (slipIds) =>
    axiosInstance.get(`/CommissionSlip/ExportMakerCsv?slipIds=${slipIds.join(',')}`);
export const getSlipById = (slipId) => axiosInstance.get(`/CommissionSlip/GetSlipById?slipId=${slipId}`);
// What has actually been PAID, per (agent, sale, comm type), from approved slips.
// The reports use this for Paid / Outstanding — the slip is the payment to the agent.
export const getPaidBreakdown = () => axiosInstance.get("/CommissionSlip/GetPaidBreakdown");

// ── Referral fee payouts ───────────────────────────────────────────────────
// An Astern-borne referral fee has no CommissionProgress row, so it never reaches the
// commission generator and nothing recorded that it was paid. The referral slip IS that
// record. (user 2026-10-14: "referral aso have a referral slip")
// The gate — customer paid 60%, then the WHOLE fee is paid once — lives in the API, not
// here. It is a business rule rather than a per-run choice. (user 2026-10-14)
export const getReferralPayable = () =>
    axiosInstance.get("/CommissionSlip/GetReferralPayable");
export const generateReferralSlips = ({ month, year, salesIds = [] }) =>
    axiosInstance.post("/CommissionSlip/GenerateReferralSlips", { month, year, salesIds });
// A payout typed on the referral detail page. Astern is the payer; this records what they
// paid, as an approved one-line referral slip. (user 2026-10-14)
export const recordReferralPayout = ({ salesId, amount, paidOn, remarks }) =>
    axiosInstance.post("/CommissionSlip/RecordReferralPayout", { salesId, amount, paidOn, remarks });
